import { useState, useEffect } from 'react';

const useResponsiveWidth = (defaultWidth = '120px', largeWidth = '180px', breakpoint = 1600) => {
    const [width, setWidth] = useState(defaultWidth);

    const handleResize = () => {
        setWidth(window.innerWidth >= breakpoint ? largeWidth : defaultWidth);
    };

    useEffect(() => {
        handleResize(); // Set initial width on mount
        window.addEventListener('resize', handleResize); // Update width on resize

        return () => {
            window.removeEventListener('resize', handleResize); // Cleanup listener
        };
    }, [defaultWidth, largeWidth, breakpoint]);

    return width;
};

export default useResponsiveWidth;
